import { vec3, mat4 } from 'gl-matrix';

import constants from '../../settings/constants';

function calculateVertices(item) {
  return [
    // 0: front bottom left
    [0, 0, item.depth],
    // 1: front bottom right
    [item.width, 0, item.depth],
    // 2: front top right
    [item.width, item.height, item.depth],
    // 3: front top left
    [0, item.height, item.depth],
    // 4: rear bottom left
    [0, 0, 0],
    // 5: rear bottom right
    [item.width, 0, 0],
    // 6: rear top right
    [item.width, item.height, 0],
    // 7: rear top left
    [0, item.height, 0],
  ];
}

function calculateViewProjection() {
  const cameraPosition = [0, 0, 1];
  const cameraLookAt = [0, 0, 0];
  const cameraUp = [0, 1, 0];

  const view = mat4.lookAt(
    mat4.create(),
    cameraPosition,
    cameraLookAt,
    cameraUp
  );

  const projection = mat4.ortho(mat4.create(), -1, 1, -1, 1, 0, 1000);

  // append oblique transformation
  const oblique = mat4.create();
  oblique[8] = Math.cos(constants.OBLIQUE_ANGLE) * -0.29;
  oblique[9] = Math.sin(constants.OBLIQUE_ANGLE) * -0.29;
  mat4.multiply(projection, projection, oblique);

  // combine view and projection
  const viewProjection = mat4.multiply(mat4.create(), projection, view);

  return viewProjection;
}

const viewProjection = calculateViewProjection();

function isBehind(a, b) {
  if (a.x >= b.x + b.width || (a.y >= b.y + b.height && b.x < a.x + a.width)) {
    return false;
  }

  return true;
}

function point(point) {
  return vec3.transformMat4(vec3.create(), point, viewProjection);
}

function points(points) {
  if (
    typeof points.width === 'number' &&
    typeof points.height === 'number' &&
    typeof points.depth === 'number'
  ) {
    points = calculateVertices(points);
  } else if (!Array.isArray(points)) {
    throw new Error('Only an item or array of points can be projected');
  }

  return points.map(point);
}

function face(item) {
  const vertices = calculateVertices(item).slice(0, 4);

  const projectedVertices = vertices.map(point);

  return {
    width: projectedVertices[1][0] - projectedVertices[0][0],
    height: projectedVertices[2][1] - projectedVertices[0][1],
  };
}

function outer(item) {
  const vertices = calculateVertices(item);

  const projectedVertices = vertices.map(vertex => {
    const coords = vec3.create();

    vec3.transformMat4(coords, vertex, viewProjection);

    return coords;
  });

  return {
    width: projectedVertices[5][0] - projectedVertices[0][0],
    height: projectedVertices[6][1] - projectedVertices[0][1],
  };
}

export { calculateVertices, face, outer, point, points };

export default {
  calculateVertices,
  face,
  isBehind,
  outer,
  point,
  points,
};
